import React from 'react';
import { BookOpen, Target, Users, Trophy } from 'lucide-react';

const categories = [
  {
    title: "Fiction Titles",
    examples: ["The Last Guardian", "Whispers of Eternity", "Shadow's Edge"],
    description: "Captivating titles that draw readers into your fictional world."
  },
  {
    title: "Non-Fiction Titles",
    examples: ["The Art of Success", "Mastering Mindfulness", "Essential Leadership"],
    description: "Clear, authoritative titles that convey expertise and value."
  },
  {
    title: "Academic Titles",
    examples: ["Foundations of Theory", "Advanced Research Methods", "Contemporary Analysis"],
    description: "Professional titles that reflect scholarly work and research."
  }
];

const tips = [
  {
    icon: BookOpen,
    title: "Know Your Genre",
    content: "Choose titles that match your genre's conventions and reader expectations."
  },
  {
    icon: Target,
    title: "Consider Keywords",
    content: "Include relevant keywords for better discoverability."
  },
  {
    icon: Users,
    title: "Target Audience",
    content: "Craft titles that appeal to your intended readers."
  },
  {
    icon: Trophy,
    title: "Memorability",
    content: "Create titles that stick in readers' minds."
  }
];

export default function BookGuide() {
  return (
    <section className="py-20 bg-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Book Titles
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-purple-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Choosing Your Book Title
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 mb-4">
                  <tip.icon className="w-6 h-6 text-purple-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}